module.exports = __webpack_public_path__ + "img/open_mode1.e617120d.jpg";